import axios from 'axios'

export default async ({ url }) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'DELETE',
      url: `${process.env.REACT_APP_API_KEY}${url}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(function (response) {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}
